import vue from 'vue';
import vuePower from 'vue-power-show';
import vueXUI from 'vue-element-xui';
import { getPowerHandler } from './power';
import { getDataDetailHandler, getDataListHandler, getUploadFileHandler } from './xui';

// vuePower
vue.use(vuePower);
vuePower.setPowerHandler(getPowerHandler);

// vueXUI
vue.use(vueXUI, {
  size: "medium",
  drawerModel: true,
  drawerLeftSize: 150,
  drawerFullScreen: true,
  drawerBackLabel: "返回"
});
vueXUI.setDataListHandler(getDataListHandler)
vueXUI.setDataDetailHandler(getDataDetailHandler)
vueXUI.setFileUploadHandler(getUploadFileHandler)